var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_148187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9603 11.96C10.8207 12.8286 9.43306 13.3099 8.00033 13.3333C3.33366 13.3333 0.666992 7.99998 0.666992 7.99998C1.49625 6.45457 2.64642 5.10438 4.04033 4.03998M6.60033 2.82664C7.05921 2.71923 7.52904 2.66554 8.00033 2.66664C12.667 2.66664 15.3337 7.99998 15.3337 7.99998C14.929 8.75705 14.4464 9.4698 13.8937 10.1266M9.41366 9.41331C9.23056 9.60981 9.00976 9.76741 8.76443 9.87673C8.5191 9.98604 8.25426 10.0448 7.98572 10.0496C7.71718 10.0543 7.45043 10.0049 7.2014 9.9043C6.95236 9.80371 6.72614 9.654 6.53622 9.46408C6.34631 9.27416 6.19659 9.04794 6.096 8.7989C5.99541 8.54987 5.94601 8.28312 5.95075 8.01458C5.95549 7.74604 6.01426 7.48121 6.12358 7.23587C6.23289 6.99054 6.39049 6.76974 6.58699 6.58664",
    stroke: "#A5A5A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0.666687L15.3337 15.3334",
    stroke: "#A5A5A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_148187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.3f8bfb0bd01caa73c07ea2b8547d6adf.svg";
export { ForwardRef as ReactComponent };